import jQuery from "jquery";
import {getCookie} from "./gppy-misc";

export function purchase(email, product, countryCode, autoRenew, discountCode, invoiceNeeded) {
    var data = {
        email: email,
        product: product,
        country: countryCode,
        autoRenew: autoRenew,
        invoiceNeeded: invoiceNeeded
    }
    if (discountCode)
        data["discountCode"] = discountCode;
    Promise.resolve(jQuery.post('/api/prepareTransaction', data)).then(redirectPaymentProcessor);
}

export function subscriberPurchase(product, autoRenew, invoiceNeeded) {
    var data = {
        product: product,
        autoRenew: autoRenew,
        invoiceNeeded: invoiceNeeded
    }
    Promise.resolve(jQuery.post('/api/prepareSubscriberTransaction', data)).then(redirectPaymentProcessor);
}

function redirectPaymentProcessor(res) {
    if (res.result !== "OK") {
        alert("Problem with initiating payment. Please contact support.");
        return;
    }
    if (res.paymentProcessor === "PAYPAL")
        if (res.autorenew)
            initpaypalsubscription(res);
        else
            initpaypalpayment(res);

    if (res.paymentProcessor === "P24") {
        // if (paymentMethod === "cards") {
        //     res["p24_address"] = p24address;
        //     res["p24_zip"] = p24zipcode;
        //     res["p24_city"] = p24city;
        // }
        initp24payment(res);
    }
    sendDataToGa(res);
}

function sendDataToGa(pay_data) {
    let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({'event': 'begin_checkout', 'ecommerce': {
        "transaction_id": pay_data.transactionId,
        "affiliation": 'GardenPuzzle',
        "value": pay_data.price,
        "currency": lang === "pl" ? 'PLN' : 'USD',
        "tax": 0,
        "shipping": 0,
        "items": [
            {
                "id": pay_data.product,
                "name": pay_data.product,
                "quantity": 1,
                "price": pay_data.price
            }
        ]
    }});
}

function initpaypalpayment(pay_data) {
    paypal.Buttons({
        createOrder: function (data, actions) {
            return actions.order.create({
                application_context: {
                    brand_name: "GardenPuzzle",
                    shipping_preference: "NO_SHIPPING"
                },
                purchase_units: [{
                    amount: {
                        currency_code: "USD",
                        value: pay_data.price
                        // breakdown: {
                        //     item_total: {
                        //         currency_code: "USD",
                        //         value: pay_data.price,
                        //     }
                        // }
                    },
                    custom_id: pay_data.sessionId + "/" + pay_data.country + "/" + pay_data.item_number,
                    // items: [
                    //      {
                    //          name :  pay_data.item_name,
                    //          sku: pay_data.item_number,
                    //          quantity: 1,
                    //          unit_amount: {
                    //             currency_code: "USD",
                    //             value: pay_data.price
                    //          }
                    //      }
                    //  ]
                }]
            });
        },
        onApprove: function (data, actions) {
            return actions.order.capture().then(function(details) {
                location.href = location.origin + pay_data.return;
            });
        },
        onError: function (err) {
            alert("Transaction failed: "+err);
        }
    }).render('#paypal-button-container');

}

function initpaypalsubscription(pay_data) {
  paypal.Buttons({
      style: {
          shape: 'rect',
          color: 'gold',
          layout: 'vertical',
          label: 'subscribe'
      },
      createSubscription: function(data, actions) {
        return actions.subscription.create({
          /* Creates the subscription */
            plan_id: pay_data['planid'],
            application_context: {
                brand_name: "GardenPuzzle",
                shipping_preference: "NO_SHIPPING"
            },
            custom_id: pay_data.sessionId
        });
      },
      onApprove: function(data, actions) {
          registerSubscription(data.subscriptionID, pay_data).then(res => res.json()).then((res) => {
                if (res.result === "OK")
                    location.href = location.origin + pay_data.return
                else alert("Problem with registering subscription.")
            }).catch(() => {
                alert("Problem with registering subscription.")
            })
          //console.log(data);
          // {
          //     facilitatorAccessToken: "A21AAIg7zxxlf7u0a4FNsFBd9cIlXPhiZIURt_GSd9jBmSxvmauyIj5rKiKPups0Mgj0A9ODM_056CXxO27ByWoOwPNrT1_lQ"
          //     orderID: "35X10172Y32532443"
          //     paymentSource: "paypal"
          //     subscriptionID: "I-7RLDK467698C" --> BPP: recurring_payment_id
          // }
          //console.log(actions);
          //actions.subscription.get().then(a => console.log(a))
          //   {
          //       "status": "ACTIVE",
          //       "status_update_time": "2022-08-22T08:35:22Z",
          //       "status_changed_by": "MERCHANT",
          //       "id": "I-7RLDK467698C",
          //       "plan_id": "P-1J906246FY758382WML7Z7RQ",
          //       "start_time": "2022-08-22T08:34:49Z",
          //       "quantity": "1",
          //       "shipping_amount": {
          //           "currency_code": "PLN",
          //           "value": "0.0"
          //       },
          //       "subscriber": {
          //           "email_address": "admin-buyer@gardenpuzzle.com",
          //           "payer_id": "P872GR8F7Y2HU",
          //           "name": {
          //               "given_name": "test",
          //               "surname": "buyer"
          //           }
          //       },
          //       "billing_info": {
          //           "outstanding_balance": {
          //               "currency_code": "PLN",
          //               "value": "0.0"
          //           },
          //           "cycle_executions": [
          //               {
          //                   "tenure_type": "TRIAL",
          //                   "sequence": 1,
          //                   "cycles_completed": 1,
          //                   "cycles_remaining": 0,
          //                   "current_pricing_scheme_version": 1,
          //                   "total_price_per_cycle": {
          //                       "gross_amount": {
          //                           "currency_code": "PLN",
          //                           "value": "119.0"
          //                       },
          //                       "total_item_amount": {
          //                           "currency_code": "PLN",
          //                           "value": "119.0"
          //                       },
          //                       "shipping_amount": {
          //                           "currency_code": "PLN",
          //                           "value": "0.0"
          //                       },
          //                       "tax_amount": {
          //                           "currency_code": "PLN",
          //                           "value": "0.0"
          //                       }
          //                   },
          //                   "total_cycles": 1
          //               },
          //               {
          //                   "tenure_type": "REGULAR",
          //                   "sequence": 2,
          //                   "cycles_completed": 0,
          //                   "cycles_remaining": 0,
          //                   "current_pricing_scheme_version": 1,
          //                   "total_price_per_cycle": {
          //                       "gross_amount": {
          //                           "currency_code": "PLN",
          //                           "value": "39.0"
          //                       },
          //                       "total_item_amount": {
          //                           "currency_code": "PLN",
          //                           "value": "39.0"
          //                       },
          //                       "shipping_amount": {
          //                           "currency_code": "PLN",
          //                           "value": "0.0"
          //                       },
          //                       "tax_amount": {
          //                           "currency_code": "PLN",
          //                           "value": "0.0"
          //                       }
          //                   },
          //                   "total_cycles": 0
          //               }
          //           ],
          //           "last_payment": {
          //               "amount": {
          //                   "currency_code": "PLN",
          //                   "value": "119.0"
          //               },
          //               "time": "2022-08-22T08:35:21Z"
          //           },
          //           "next_billing_time": "2023-02-22T10:00:00Z",
          //           "failed_payments_count": 0
          //       },
          //       "create_time": "2022-08-22T08:35:21Z",
          //       "update_time": "2022-08-22T08:35:22Z",
          //       "custom_id": "b8f9187e96c2b76f133e5621c9d818b8/US/P_PR/26300/marek.rafalowicz+s1@gmail.com",
          //       "plan_overridden": false,
          //       "links": [
          //           {
          //               "href": "https://api.sandbox.paypal.com/v1/billing/subscriptions/I-7RLDK467698C/cancel",
          //               "rel": "cancel",
          //               "method": "POST"
          //           },
          //           {
          //               "href": "https://api.sandbox.paypal.com/v1/billing/subscriptions/I-7RLDK467698C",
          //               "rel": "edit",
          //               "method": "PATCH"
          //           },
          //           {
          //               "href": "https://api.sandbox.paypal.com/v1/billing/subscriptions/I-7RLDK467698C",
          //               "rel": "self",
          //               "method": "GET"
          //           },
          //           {
          //               "href": "https://api.sandbox.paypal.com/v1/billing/subscriptions/I-7RLDK467698C/suspend",
          //               "rel": "suspend",
          //               "method": "POST"
          //           },
          //           {
          //               "href": "https://api.sandbox.paypal.com/v1/billing/subscriptions/I-7RLDK467698C/capture",
          //               "rel": "capture",
          //               "method": "POST"
          //           }
          //       ]
          //   }
//          location.href = location.origin + pay_data.return;
//        return actions.order.capture().then(function(details) {
//            location.href = location.origin + pay_data.return;
//        });
      }
  }).render('#paypal-button-container');
}

function registerSubscription(subscriptionID, pay_data) {
    let params = 'subscription_id=' + subscriptionID + '&session_id='+pay_data.sessionId;
    return fetch('/api/registerSubscription', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json',
            'X-CSRFToken': getCookie('csrftoken')
        },
        body: params
    })
}

function initp24payment(data) {
    const form = document.createElement('form');
    form.method = "post";
    form.action = data.action;

    let params = {
        "p24_currency": "PLN",
        "p24_language": "pl",
        "p24_api_version": "3.2",
        "p24_session_id": data.sessionId,
        "p24_merchant_id": data.sellerId,
        "p24_pos_id": data.sellerId,
        "p24_email": data.email,
        "p24_client": data.name,
        "p24_country": data.country,
        "p24_url_return": location.origin + data.return,
        "p24_url_status": location.origin + data.p24_url_status,
        "p24_description": data.item_name,
        "p24_amount": data.price,
        "p24_sign": data.sign
        // "p24_adddatas": data.p24address,
        // "p24_zip": data.p24zipcode,
        // "p24_city": data.p24city
    }

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = params[key];
            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    form.submit();
}